<section class="innerpage_sec">
  <div class="elevation_left"></div>
  <div class="photo_overlay_center"></div>
  <div class="photo_overlay_right"></div>
  <!-- banner_flower -->
  <div class="banner_flower sec-padding">
    <!-- <img src="../../../../../assets/images/banner-elevation.png" alt="img"> -->
  </div>
  <div class="wrapper">
    <div class="wrapper">
      <div class="swiper-button-prev initiatives-button-prev">
        <img src="../../../../../assets/images/ic/left-arrow.svg" alt="" srcset="">
      </div>
    <div class="swiper-container" [swiper]="config">
      <div class="swiper-wrapper">
        <!-- FIRST -->
        <div class="swiper-slide" [ngClass]="{'custom-active-slide': singleSection.id === selectedSectionId}" *ngFor="let singleSection of sections">
          <div class="card_box" [ngStyle]="{'background-image':'url('+eventsSettings[singleSection.id].image.url+')'}">
            <a [routerLink]="['../', singleSection.id]" queryParamsHandling="merge">
              <div class="card_img">
                <h5 *ngIf="lang==='en'" [innerHtml]="eventsSettings[singleSection.id].en_title"> </h5>
                <h5 *ngIf="lang==='te'" [innerHtml]="eventsSettings[singleSection.id].te_title"> </h5>
              </div>
            </a>
          </div>
          <div class="banner_overlay"></div>
        </div>
      </div>
      <!-- <div class="navigations">
        <div class="swiper-button-prev initiatives-button-prev">
          <img src="../../../../../assets/images/next.png" alt="" srcset="">
        </div>
        <div class="swiper-button-next initiatives-button-next">
          <img src="../../../../../assets/images/next.png" alt="" srcset="">
        </div>
      </div> -->
      <div class="swiper-pagination swiper-pagination-banner"></div>
    </div>
    <div class="custom_heading">
      <h2 class="title" [innerHtml]="selectedSection.en_title">
      </h2>
    </div>
    <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
      fxLayoutAlign="start stretch" fxLayoutGap="15px">
      <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>
        <div class="widhun">
          <ng-container *ngIf="lang === 'en'; else teluguTemplate">
            <div [innerHtml]="selectedSection.en_content"></div>
          </ng-container>
          <ng-template #teluguTemplate>
            <h6 [innerHtml]="selectedSection.te_title"></h6>
            <div [innerHtml]="selectedSection.te_content"></div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div class="swiper-button-next initiatives-button-next">
    <img src="../../../../../assets/images/ic/right-arrow.svg" alt="" srcset="">
  </div>
  </div>
</section>
<!-- <section class="innerpage_bottom_sec">
  <div class="initiatives_top"></div>
</section> -->
